var _Circle, _Path, _Path2, _Path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
var SvgCashInBag = function SvgCashInBag(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Circle || (_Circle = /*#__PURE__*/React.createElement(Circle, {
    cx: 30.5,
    cy: 30.5,
    r: 28,
    stroke: "#4285F4",
    strokeWidth: 4
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M42.629 41.916c0-15.653-6.916-18.923-8.44-19.454l3.476-7.439a1.238 1.238 0 0 0-.528-1.604l-7.144-3.795c-.566-.3-1.17-.037-1.345.584l-1.85 5.813a.537.537 0 1 1-1.022-.334l.827-2.582-4.448.996c-.623.14-.84.691-.48 1.224l4.469 6.551h3.931a.54.54 0 0 1 .538.543c0 .3-.24.542-.538.542h-4.658c-2.46 1.38-7.358 5.782-7.358 18.955 0 0-2.559 1.956-2.559 5.084H45.187c0-3.128-2.558-5.084-2.558-5.084Z",
    fill: "#494949"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    d: "M37.922 36.39a7.811 7.811 0 1 1-15.158-3.781 7.811 7.811 0 0 1 15.158 3.78Z",
    fill: "#F7931A"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.648 33.248c.155-1.024-.636-1.574-1.718-1.941l.35-1.387-.856-.21-.342 1.35a36.45 36.45 0 0 0-.687-.16l.344-1.358-.856-.21-.352 1.386a28.89 28.89 0 0 1-.547-.127v-.004l-1.181-.291-.228.901s.636.144.622.153c.347.085.41.311.4.49l-.4 1.58a.731.731 0 0 1 .089.028l-.03-.007-.06-.015-.561 2.213c-.043.104-.15.26-.393.2.008.013-.623-.153-.623-.153l-.426.967 1.116.273.37.094.24.061-.354 1.403.856.21.352-1.387c.234.062.46.12.683.174l-.35 1.381.857.21.355-1.4c1.461.273 2.56.163 3.023-1.138.373-1.048-.019-1.653-.788-2.047.56-.127.982-.49 1.095-1.24Zm-1.959 2.703c-.242.962-1.771.564-2.47.383-.064-.017-.12-.032-.168-.043l.471-1.858.21.048c.724.16 2.207.487 1.957 1.47Zm-1.812-2.332c.583.154 1.855.488 2.077-.386.226-.894-1.01-1.164-1.614-1.295l-.177-.04-.427 1.685.141.036Z",
    fill: "white"
  })));
};
export default SvgCashInBag;